
__webpack_require__.debugRequireIds = {
	"-!./debug-require.cjs": 2800,
	"-!jquery": 49949,
	"./debug-require.cjs": 21962,
	"./src/base_page_params.ts": 70142,
	"./src/blueslip.ts": 14700,
	"./src/blueslip_stacktrace.ts": 98874,
	"./src/bot_types.ts": 40879,
	"./src/bundles/common.ts": 31593,
	"./src/bundles/portico.ts": 4338,
	"./src/csrf.ts": 23640,
	"./src/portico/communities.ts": 19026,
	"./src/portico/google-analytics.ts": 45953,
	"./src/portico/header.ts": 33670,
	"./src/portico/portico_modals.ts": 69152,
	"./src/portico/tippyjs.ts": 51242,
	"./src/realm_user_settings_defaults.ts": 23786,
	"./src/sentry.ts": 50673,
	"./src/state_data.ts": 92300,
	"./src/stream_types.ts": 14512,
	"./src/types.ts": 90693,
	"./src/user_settings.ts": 38701,
	"./src/user_status_types.ts": 51828,
	"./styles/portico/integrations.css": 9421,
	"./styles/portico/landing_page.css": 61925,
	"./templates/blueslip_stacktrace.hbs": 24075,
	"core-js/modules/es.array.push.js": 78893,
	"core-js/modules/es.iterator.constructor.js": 52476,
	"core-js/modules/es.iterator.find.js": 3325,
	"core-js/modules/es.iterator.map.js": 92578,
	"core-js/modules/esnext.json.parse.js": 38968,
	"core-js/modules/web.url-search-params.delete.js": 22710,
	"core-js/modules/web.url-search-params.has.js": 16077,
	"core-js/modules/web.url-search-params.size.js": 72128,
	"error-stack-parser": 69363,
	"ga-gtag": 78406,
	"handlebars/runtime.js": 81942,
	"jquery": 58254,
	"micromodal": 98476,
	"minimalistic-assert": 45185,
	"source-map": 68068,
	"stackframe": 36854,
	"stacktrace-gps": 14021,
	"tippy.js": 99947,
	"tippy.js/dist/tippy.css": 29445
};